import api from './client.js'

export const chatAPI = {
  getRooms: () => api.get('/chat/rooms'),
  createRoom: (roomData) => api.post('/chat/rooms', roomData),
  deleteRoom: (roomId) => api.delete(`/chat/rooms/${roomId}`),
  joinRoom: (roomId) => api.post(`/chat/rooms/${roomId}/join`),
  leaveRoom: (roomId) => api.post(`/chat/rooms/${roomId}/leave`),
  getRoomMembers: (roomId) => api.get(`/chat/rooms/${roomId}/members`),
  getMessages: (roomId, params) => api.get(`/chat/rooms/${roomId}/messages`, { params }),
  sendMessage: (roomId, message) => api.post(`/chat/rooms/${roomId}/messages`, { message }),
  deleteMessage: (messageId) => api.delete(`/chat/messages/${messageId}`),
  clearRoomMessages: (roomId) => api.delete(`/chat/rooms/${roomId}/clear`),
  muteUser: (userId, muteData) => api.post(`/chat/users/${userId}/mute`, muteData),
  unmuteUser: (userId, data) => api.post(`/chat/users/${userId}/unmute`, data),
  getMutedUsers: () => api.get('/chat/muted-users'),
}
